import i18n from "i18next";

import { SeniorsWorkoutFrequencyAnswers } from "@/types/answers";
import { Genders } from "@/types/gender";

export const enum FitnessLevels {
    Beginner = "beginner",
    Intermediate = "intermediate",
    Advanced = "advanced",
}

export const workoutFrequencyToFitnessLevel: Record<SeniorsWorkoutFrequencyAnswers, FitnessLevels> =
    {
        [SeniorsWorkoutFrequencyAnswers.AlmostEveryDay]: FitnessLevels.Advanced,
        [SeniorsWorkoutFrequencyAnswers.SeveralTimesAWeek]: FitnessLevels.Intermediate,
        [SeniorsWorkoutFrequencyAnswers.SeveralTimesAMonth]: FitnessLevels.Intermediate,
        [SeniorsWorkoutFrequencyAnswers.Never]: FitnessLevels.Beginner,
    };

export const getFitnessLevelLabel = (level: FitnessLevels, gender: Genders) =>
    i18n.t(level, {
        context: gender,
        defaultValue: level,
    });
